import { useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import { setBalance } from "../../components/store/balance/balanceSlice";
import { axiosPostApi } from "../../helpers/interceptorServices";
import { apiList } from "../../helpers/apiList";
import { formatDateToYYYYMMDD } from "../../helpers/DateHelpers";

export const useDashboardData = (loggedInUserName) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchDashboardData = useCallback(
    async (page = 1) => {
      setLoading(true);
      setError(null);

      try {
        const endDate = formatDateToYYYYMMDD(new Date());
        const startDate1 = new Date(
          new Date().setDate(new Date().getDate() - 90)
        );
        const finalStartDate = formatDateToYYYYMMDD(startDate1);

        const requestBody = {
          startDate: finalStartDate,
          endDate: endDate,
          username: loggedInUserName,
        };

        const response = await axiosPostApi(
          apiList.DASHBOARD_DATA,
          requestBody
        );

        if (response?.status === 200 && response?.data?.respCode === "00") {
          dispatch(setBalance(response?.data?.data?.balanceDetails));
          // if you want to fetch extra data
          // fetchData(page);
        } else {
          setError("Failed to fetch dashboard data");
        }
      } catch (err) {
        console.error("Error fetching dashboard data", err);
        setError(err.message || "Something went wrong");
      } finally {
        setLoading(false);
      }
    },
    [dispatch, loggedInUserName]
  );

  return { fetchDashboardData, loading, error };
};
